<app-login-payment (eventLoggedIn)="loggedIn()" (eventRegister)="register()" (eventRegisterAsGuest)="registerAsGuest()" [showGuestRegister]="false"></app-login-payment>
